import { render, staticRenderFns } from "./renewSetMeal.vue?vue&type=template&id=4521476c&scoped=true"
import script from "./renewSetMeal.vue?vue&type=script&lang=js"
export * from "./renewSetMeal.vue?vue&type=script&lang=js"
import style0 from "./renewSetMeal.vue?vue&type=style&index=0&id=4521476c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521476c",
  null
  
)

export default component.exports